// extracted by mini-css-extract-plugin
module.exports = {"inputLabel":"ImageUpload_inputLabel__2R1X1","icon":"ImageUpload_icon__1PGsX","span":"ImageUpload_span__2BhKz","imagePreview":"ImageUpload_imagePreview__1njcw"};